import React from "react";
import { DmIcon } from "@dm-portal/styleguide";

import "./servicecard.css";

const ServiceCard = ({
  serviceName,
  serviceIcon,
  serviceDescription,
  size,
  url,
  disabled,
  ...props
}) => {
  return (  
    <div
      onClick={disabled ? null : () => singleSpaNavigate(url)}
      className={`dm-home-service-card ${disabled ? "dm-home-service-card-disabled " : ""} ${
        size === "big"
          ? "dm-home-service-card-big"
          : "dm-home-service-card-small"
      }`}
    >
      <div className="dm-home-service-card-top-wrap">
        <span>
        <DmIcon icon={serviceIcon} />
        </span>
        <span className="dm-home-service-card-title">{serviceName}</span>
      </div>
      <div style={{ marginTop: 10 }}>
        <span className="dm-home-service-card-description">
          {serviceDescription}
        </span>
      </div>
    </div>
  );
};

export default ServiceCard;
